import { render, staticRenderFns } from "./form-municipios.vue?vue&type=template&id=d67a3698&"
import script from "./form-municipios.vue?vue&type=script&lang=js&"
export * from "./form-municipios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports